var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[_c('LeftHierarchy',{ref:"leftHierarchyRef"}),_c('RightDevice',{ref:"rightDeviceRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }